module.exports = __webpack_public_path__ + "img/xiaochengxuERCode.e5d5dc8e.png";